// src/components/Experience.js
import { useState } from 'react';
import { experiences } from '../data';
import './Experience.css';

const Experience = () => {
  const [sectionCollapsed, setSectionCollapsed] = useState(false);
  const [collapsedExperiences, setCollapsedExperiences] = useState({});

  const toggleSection = () => {
    setSectionCollapsed(!sectionCollapsed);
  };

  const toggleExperience = (expId) => {
    setCollapsedExperiences(prev => ({
      ...prev,
      [expId]: !prev[expId]
    }));
  };

  return (
    <section id="experience" className="experience-section">
      <h2 onClick={toggleSection} className="section-header-clickable">
        Expériences Professionnelles & Associatives
        <span className="toggle-icon">{sectionCollapsed ? '▼' : '▲'}</span>
      </h2>
      {!sectionCollapsed && (
        <div className="experience-timeline">
          {experiences.map((exp) => {
            const isCollapsed = collapsedExperiences[exp.id];
            return (
              <div key={exp.id} className="timeline-item">
                <div className={`timeline-content ${isCollapsed ? 'collapsed' : ''}`}>
                  <div className="experience-header" onClick={() => toggleExperience(exp.id)}>
                    {exp.logo && (
                      <div className="company-logo">
                        <img src={exp.logo} alt={`${exp.company} logo`} />
                      </div>
                    )}
                    <div className="experience-header-info">
                      <h3>{exp.title}</h3>
                      <span className="company">{exp.company}</span>
                      <span className="years">{exp.years}</span>
                    </div>
                    <span className="toggle-icon-exp">{isCollapsed ? '▼' : '▲'}</span>
                  </div>

                  {!isCollapsed && (
                    <>
                      <ul>
                        {exp.description.map((point, index) => (
                          <li key={index}>{point}</li>
                        ))}
                      </ul>
                      {exp.tags && (
                        <div className="tags">
                          {exp.tags.map((tag, index) => (
                            <span key={index} className="tag">{tag}</span>
                          ))}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default Experience;